<template>
    <div>
        <el-form :model="purchReceipt" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <div class="content-caption dashed">
                <span>验收单信息</span>
                <div class="input-tip error font12">临采的资产因供应商线下维保，无法按保内处理</div>
            </div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">请购部门/门店</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="recvComName">
                            <el-input class="width-1-5x bottom-line" :disabled="true" v-model="purchReceipt.recvComName"></el-input>
                            <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="selectSrcComName"></i>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">标题</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="title">
                            <el-input type="text" v-model="purchReceipt.title"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">外部审批单号</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="auditPoofNo">
                            <el-input type="text" v-model="purchReceipt.auditPoofNo"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="showBizUnitWarehouse">
                    <div class="form-label">
                        <label class="required">入库仓库</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="warehouseId">
                            <el-select v-model="purchReceipt.warehouseId" :clearable=true>
                                <el-option v-for="item in warehouseList" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
            </div>

            <div class="content-caption dashed">
                <span>供应商信息</span>
                <a class="swb-btn swb-btn-small" @click="selectTmpVendor()">选择供应商</a>
            </div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>供应商名称</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.sellerRealComName || '' }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>统一社会代码</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.sellerSocialCreditCode || '' }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>业务联系人</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.sellerContactName || '' }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>业务联系方式</label>
                    </div>
                    <div class="form-value">
                        <span>{{ purchReceipt.sellerContactTel || '' }}</span>
                    </div>
                </div>
            </div>

            <div class="content-caption dashed">
                <span>结算单信息</span>
            </div>
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>发票类型</label>
                    </div>
                    <div class="form-value">
                        <ul class="enum-list">
                            <li class="enum-item" :class="{checked : (merchantInvoiceType.value == purchReceipt.invoiceType)}" v-for="merchantInvoiceType in invoiceTypeList" @click="invoiceTypeChange(merchantInvoiceType.value)">
                                {{ merchantInvoiceType.text }}<i></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">是否抵扣税</label>
                    </div>
                    <div class="form-value">
                        <span v-if="purchReceipt.invoiceType == 1">否</span>
                        <el-form-item prop="taxOffset" v-else>
                            <el-select v-model="purchReceipt.taxOffset" placeholder="请选择" @change="changeTaxOffset()">
                                <el-option label="是" :value="true"></el-option>
                                <el-option label="否" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">税率(%)</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="taxRate">
                            <el-select v-model="purchReceipt.taxRate" placeholder="请选择税率" @change="changeActualAmount()">
                                <el-option v-for="item in fiscalTaxMarkList" :key="item.rate" :label="item.rate" :value="item.rate"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
            </div>

            <div class="content-caption dashed">
                <span>验收条目</span>
                <a class="swb-btn swb-btn-small" @click="showDevcDefListDlg()">选择资产定义</a>
            </div>
            <div class="table-layout">
                <div v-if="purchReceipt.goodsItemList != null && purchReceipt.goodsItemList.length > 0">
                    <div class="simple-row">
                        <div class="right">
                            <span v-if="purchReceipt.goodsItemList != null">已选择({{ purchReceipt.goodsItemList.length }})</span>
                        </div>
                    </div>
                    <el-table ref="multipleTable" :data="purchReceipt.goodsItemList" border tooltip-effect="dark" maxHeight="400" style="width: 100%">
                        <el-table-column align="left" prop="assetDefNo" label="资产定义编码" width="200" fixed="left" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="assetDefName" label="资产定义名称" width="100" fixed="left" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="assetNature" label="资产属性" width="100" fixed="left" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ assetNatureMap[rows.row.assetNature] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" prop="model" label="型号" width="150" fixed="left" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="fixedSpec" label="规格" width="150" fixed="left" show-overflow-tooltip></el-table-column>
                        <el-table-column align="center" prop="brandName" label="资产品牌" width="240"></el-table-column>
                        <el-table-column align="center" prop="catName" label="资产分类" width="240"></el-table-column>
                        <el-table-column align="right" prop="wtxPrice" width="100" label="含税单价(元)">
                            <template slot-scope="rows">
                                <el-form-item :prop="'goodsItemList.' + rows.$index + '.wtxPrice'" :rules="{validator: validateWtxPrice, trigger: 'blur'}">
                                    <el-input type="text" v-model="rows.row.wtxPrice" @change="wtxPriceChange(rows.row)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="wrntPeriod" width="100" label="质保期(月)">
                            <template slot-scope="rows">
                                <el-input type="text" v-model="rows.row.wrntPeriod"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="quantity" width="100" label="数量">
                            <template slot-scope="rows">
                                <el-input type="text" v-model="rows.row.quantity" @change="quantityChange(rows.row)"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="taxRate" align="right" width="100" label="税率(%)">
                            <template slot-scope="rows">
                                <span>{{ parseFloat(rows.row.taxRate).toFixed(2) || 0.00 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ntxPrice" align="right" width="100" label="未税单价(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.ntxPrice != null">{{ parseFloat(rows.row.ntxPrice).toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="wtxAmount" align="right" width="100" label="含税小计(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.wtxAmount != null">{{ parseFloat(rows.row.wtxAmount).toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ntxAmount" align="right" width="100" label="未税小计(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.ntxAmount != null">{{ parseFloat(rows.row.ntxAmount).toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="taxAmount" align="right" width="100" label="税额小计(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.taxAmount != null">{{ parseFloat(rows.row.taxAmount).toFixed(2) }}</span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="unit" min-width="50" label="单位"></el-table-column>
                        <el-table-column align="center" width="100" label="操作" fixed="right">
                            <template slot-scope="rows">
                                <a class="swb-btn-link" @click="removeGoods(rows.$index)">移除</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-form>
        <div class="content-caption dashed">
            <span>附件信息</span>
        </div>
        <a class="swb-btn swb-btn-small" @click="showDialogFile();">上传</a>
        <div class="file-view-list" v-if="fileList != null && fileList.length > 0">
            <div class="file-view-header">
                <div class="file-name">名称</div>
                <div class="file-opera">操作</div>
            </div>
            <template v-for="(fileInfo, index) in fileList">
                <swb-file-item-li :trackKey="index" :fileName="fileInfo.name" :fileBrowseUrl="fileInfo.fileBrowseUrl" :fileDownloadUrl="fileInfo.fileBrowseUrl" :fileUuid="fileInfo.fileUuid" :deletable="true" :onDelete="deleteFile"></swb-file-item-li>
            </template>
        </div>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { MsgBox, Vue } from '../../app.vues'
import { getMerchantBizParam } from '../asset/assetMain'

import receiptApi from '../../api/receipt'
import merchtComnApi from '../../api/merchtComn'
import shopStockApi from '../../api/shopStock'
import retailerApi from '../../api/retailer'
import fiscalBizApi from '../../api/fiscalBiz';
import { showMerchtDevcDefSelectDlg } from '../devcDef/showDlg';
import {selectRealAdoptedComDlg} from "../realCom/dialog";

export default {
    name: 'swb-purch-receipt-temp-save',
    desc: '购置验收保存',
    props: {
        id: {
            type: Number,
            default: null
        },
        srcReceiptId: {
            type: Number,
            default: null
        }
    },
    data: function () {
        let checkNull = function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback(new Error('不能为空'));
            } else {
                callback();
            }
        };
        return {
            purchReceipt: {
                goodsItemList: [],
                tradeNo: null,
                taxRate: null,
                invoiceType: 1,
                autoReceive: false
            },
            fileList: [],
            rules: {
                title: [{validator: checkNull, trigger: 'blur'}],
                auditPoofNo: [{validator: checkNull, trigger: 'blur'}],
                warehouseId: [{validator: checkNull, trigger: 'change'}],
                taxRate: [{validator: checkNull, trigger: 'change'}]
            },
            assetNatureMap: getEnumMap('assetNature', 'value2text'),
            //
            invoiceTypeList: [],
            fiscalTaxMarkList: [],
            warehouseList: [],
            showBizUnitWarehouse: false,
            normalFlag: false
        }
    },
    created: function () {
        let self = this;
        getMerchantBizParam('show.biz.unit.warehouse', function (result) { // 显示门店/机构的仓库： {}
            self.showBizUnitWarehouse = Utils.isTrue(result);
        });
        // 发票类型
        let invoiceTypeList = getEnumList('invoiceType');
        for(let i = 0; i < invoiceTypeList.length; i++) {
            let invoiceType = invoiceTypeList[i];
            if(invoiceType.value == 0 || invoiceType.value == 3) {
                invoiceTypeList.splice(i, 1);
                i--;
            }
        }
        this.invoiceTypeList = Utils.merge([], invoiceTypeList);
        //
        if(!Utils.isNoB(this.id)) {
            this.getpurchReceiptDetail(this.id, false);
        } else if(!Utils.isNoB(this.srcReceiptId)) {
            // 重新生成
            this.getpurchReceiptDetail(this.srcReceiptId, true);
        }
        this.getFiscalTaxMarkList();
    },
    methods: {
        getpurchReceiptDetail: function (id, createNewVoucher) {
            let self = this;
            let postData = {};
            postData.id = id;
            //
            let msgBoxDlg = MsgBox.loading();
            receiptApi.getPurchReceiptInfo(postData, function (result) {
                msgBoxDlg.close();
                if(result.type == 'info') {
                    let purchReceipt = result.data;
                    // 重新生成临采验收单
                    if(createNewVoucher) {
                        purchReceipt.id = null;
                        purchReceipt.srcReceiptId = id;
                    }
                    self.fileList = Utils.merge([], purchReceipt.fileList);
                    //
                    purchReceipt.taxRate = purchReceipt.taxRate.toFixed(2);
                    self.purchReceipt = Utils.merge({}, purchReceipt);
                    //
                    self.getWarehouseList(purchReceipt.recvBizUnitId);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getRetailerCom(comId) {
            let self = this;
            retailerApi.getRetailerCom({
                comId: comId
            }, function (result) {
                if(result.type == 'info') {
                }
            });
        },
        getFiscalTaxMarkList: function () {
            let self = this;
            let postData = {};
            postData.disabled = false;
            postData.type = getEnumInfoWith('taxType', 'name', 'JXS').value;
            //
            let theLoad = MsgBox.loading();
            fiscalBizApi.getFiscalTaxMarkPageList(postData, function (result) {
                theLoad.hide();
                if(result.type === 'info') {
                    let fiscalTaxMarkList = result.data || [];
                    if(fiscalTaxMarkList.length > 0) {
                        fiscalTaxMarkList.forEach(function (item) {
                            item.rate = parseFloat(item.rate).toFixed(2)
                        })
                    }
                    self.fiscalTaxMarkList = Utils.merge([], fiscalTaxMarkList);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        invoiceTypeChange(invoiceType) {
            let self = this;
            let purchReceipt = this.purchReceipt;
            if(invoiceType == 1) {   // 增值税普通发票
                purchReceipt.invoiceType = invoiceType;
                purchReceipt.taxOffset = false;
                self.purchReceipt = Utils.merge({}, purchReceipt);
                self.changeTaxOffset();
            } else {
                if(Utils.isNoB(purchReceipt.buyerRealComId)) {
                    MsgBox.warning('请选择验收部门');
                    return false;
                }
                purchReceipt.invoiceType = invoiceType;
                let params = {
                    invoiceType: invoiceType,
                    realComId: purchReceipt.buyerRealComId
                };
                merchtComnApi.getTaxDeductible(params, function (result) {
                    if(result.type == 'info') {
                        purchReceipt.taxOffset = Utils.isTrue(result.data);
                        self.purchReceipt = Utils.merge({}, purchReceipt);
                        self.changeTaxOffset();
                    }
                });
            }
        },
        changeTaxOffset() {
            let purchReceipt = this.purchReceipt;
            //
            if(purchReceipt.taxOffset) {
                purchReceipt.taxRate = null;
            } else {
                let fiscalTaxMarkMap = this.fiscalTaxMarkList.toMap('rate');
                if(!Utils.isNoB(fiscalTaxMarkMap['0.00'])) {
                    purchReceipt.taxRate = '0.00';
                } else {
                    purchReceipt.taxRate = null;
                }
            }
            this.purchReceipt = Utils.merge({}, purchReceipt);
            this.changeActualAmount();
        },
        // 选择验收部门
        selectSrcComName: function () {
            let self = this;
            Vue.$showDialog({
                title: '零售商机构-选择',
                width: 750,
                height: 600,
                showCloseBtn: true,
                template: '<swb-org-tree :isShowIcon="false" :isSelectThisLevel="isSelectThisLevel" :isRadio="isRadio" :isCom="isCom" :optionalState="[1,3]" :bizDepart = "true"  ref="swb_org_tree"></swb-org-tree>',
                data: {
                    isRadio: true,
                    isCom: false,
                    isSelectThisLevel: true
                },
                okClicked: function () {
                    let result = this.$refs.swb_org_tree.getDlgResult() || {};
                    if(result.type == 'info') {
                        let shopRetail = result.data || {};
                        //
                        let purchReceipt = self.purchReceipt || {};
                        purchReceipt.buyerRealComId = shopRetail.realComId;
                        purchReceipt.recvBizUnitId = shopRetail.bizUnitId;
                        purchReceipt.recvBizUnitName = shopRetail.bizUnitId;
                        purchReceipt.recvBizUnitCode = shopRetail.no;
                        purchReceipt.recvComId = shopRetail.id;
                        purchReceipt.recvComName = shopRetail.name;
                        self.purchReceipt = Utils.merge({}, purchReceipt);
                        //
                        getMerchantBizParam('asset.finac.enabled', function (result) {
                            self.normalFlag = Utils.isTrue(result);
                        }, 2, null, purchReceipt.buyerRealComId);
                        //
                        self.getWarehouseList(purchReceipt.recvBizUnitId);
                        self.changeTaxOffset();
                    } else {
                        return false;
                    }
                }
            });
        },
        // 选择临采供应商
        selectTmpVendor: function () {
            let self = this;
            // 选择入选供方公司
            selectRealAdoptedComDlg({
                checkBox: false,
                filter: {
                    peerMerchantType: getEnumInfoWith('merchantType', 'name', 'Vendor').value,
                    tempAllowed: true
                }
            }, function (realAdoptedCom, theDlg) {
                theDlg.close();
                realAdoptedCom = realAdoptedCom || {};

                let purchReceipt = self.purchReceipt || {};
                purchReceipt.sellerAdoptedComId = realAdoptedCom.id;
                purchReceipt.sellerRealComName = realAdoptedCom.peerRealComName;
                purchReceipt.sellerSocialCreditCode = realAdoptedCom.peerSocialCreditCode;
                purchReceipt.sellerContactName = realAdoptedCom.peerContactName;
                purchReceipt.sellerContactTel = realAdoptedCom.peerContactTel;
                purchReceipt.sellerType = realAdoptedCom.peerMerchantType;
                purchReceipt.sellerName = realAdoptedCom.peerRealComName;
                purchReceipt.sellerRealComName = realAdoptedCom.peerRealComName;
                purchReceipt.buyerInnerSellerCode = realAdoptedCom.peerInnerCode;
                self.purchReceipt = Utils.merge({}, purchReceipt);
            });
        },
        getWarehouseList(recvBizUnitId) {
            let self = this;
            let postData = {};
            if(!Utils.isNoB(recvBizUnitId)) {
                postData.filterItems = {
                    retailerShopId: recvBizUnitId
                };
            }
            let msgBoxDlg = MsgBox.loading();
            shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                msgBoxDlg.close();
                if(result.type == 'info') {
                    let warehouseList = result.data;
                    if(warehouseList.length > 0) {
                        warehouseList.forEach(function (row) {
                            if(row.defaulted == true) {
                                self.purchReceipt.warehouseId = row.id;
                            }
                        })
                    }
                    self.warehouseList = Utils.merge([], warehouseList);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 选择资产定义 - 资产定义界面不显示必须集中采购的资产定义
        showDevcDefListDlg: function () {
            let self = this;
            let goodsItemList = self.purchReceipt.goodsItemList || [];
            let selectIds = [];
            for(let i = 0; i < goodsItemList.length; i++) {
                let itemInfo = goodsItemList[i];
                selectIds.push(itemInfo.assetDefId);
            }
            showMerchtDevcDefSelectDlg({
                checkBox: true,
                normalized: Utils.isTrue(self.normalFlag) ? true : null,
                tempOnly: true,
                selectIds: selectIds,
                filter: {
                    disabled: false,
                    queryOneAdoptedDevice: true // 查询一个入选商品
                },
                metaConfKey: 'swb-mercht-devc-def-list-select-forReceiptTmp'
            }, function (devcDefs, dlg) {
                dlg.close();
                devcDefs = devcDefs || [];
                let goodsList = [];
                for(let i = 0; i < devcDefs.length; i++) {
                    let devcDef = devcDefs[i];
                    let goodsInfo = {};
                    self.makePurchReceiptGoodsItemInfo(goodsInfo, devcDef);
                    goodsList.push(goodsInfo);
                }
                goodsItemList = goodsItemList.concat(goodsList);
                self.purchReceipt.goodsItemList = Utils.merge([], goodsItemList);
            });
        },
        makePurchReceiptGoodsItemInfo: function (goodsInfo, devcDef) {
            // 此处只设置前端显示+后台查询的条件信息。具体验收条目后台重新组装
            goodsInfo.assetDefId = devcDef.id;
            goodsInfo.assetDefNo = devcDef.innerCode;
            goodsInfo.assetDefName = devcDef.name;
            goodsInfo.assetNature = devcDef.assetNature;
            goodsInfo.model = devcDef.model;
            goodsInfo.fixedSpec = devcDef.fixedSpec;
            goodsInfo.brandName = devcDef.innerDevcBrandName;
            goodsInfo.catName = devcDef.innerDevcCatName;
            goodsInfo.wtxPrice = 0.00;  // 含稅单价
            goodsInfo.quantity = 1;
            goodsInfo.taxRate = Utils.isNoB(this.purchReceipt.taxRate) ? 0 : parseFloat(this.purchReceipt.taxRate).toFixed(2);
            goodsInfo.ntxPrice = 0.00;
            goodsInfo.wtxAmount = 0.00;
            goodsInfo.ntxAmount = 0.00;
            goodsInfo.taxAmount = 0.00;
            goodsInfo.unit = devcDef.theUnit;
            goodsInfo.wrntPeriod = 0;
        },
        // 税率-实际金额change事件
        changeActualAmount: function () {
            let receipt = this.purchReceipt || {};
            // 税率发生变化，条目中的税率跟着一起变
            let goodsItemList = receipt.goodsItemList || [];
            for(let i = 0, len = goodsItemList.length; i < len; i++) {
                let item = goodsItemList[i];
                item.taxRate = parseFloat(receipt.taxRate || 0).toFixed(2);
                item.ntxPrice = parseFloat((item.wtxPrice || 0) / (1 + (parseFloat(item.taxRate) * 0.01))).toFixed(2);
                item.ntxAmount = parseFloat((item.ntxPrice) * (item.quantity || 0)).toFixed(2);
                item.taxAmount = parseFloat((item.wtxAmount || 0) - parseFloat(item.ntxAmount)).toFixed(2);
            }
            receipt.goodsItemList = Utils.merge([], goodsItemList);
            this.purchReceipt = Utils.merge({}, receipt);
        },
        // 含税单价变更
        wtxPriceChange: function (row) {
            let wtxPrice = row.wtxPrice;
            if(Utils.isNoB(wtxPrice) || !Utils.isMoneyStr(wtxPrice) || wtxPrice <= 0) {
                row.wtxPrice = 0.00;
                MsgBox.warning('只能输入有效的单价！');
            } else {
                // 计算未税价
                row.ntxPrice = (parseFloat(wtxPrice / (1 + (row.taxRate * 0.01)))).toFixed(2);
                // 计算小计（含税小计，未税小计，税额小计）
                row.wtxAmount = (wtxPrice * row.quantity).toFixed(2);
                row.ntxAmount = (row.ntxPrice * row.quantity).toFixed(2);
                row.taxAmount = (row.wtxAmount - row.ntxAmount).toFixed(2);
            }
        },
        // 数量变更
        quantityChange: function (row) {
            let quantity = row.quantity;
            if(Utils.isNoB(quantity) || !Utils.isNaturalStr(quantity) || quantity <= 0) {
                row.quantity = 1;
                MsgBox.warning('只能输入大于0的整数！');
            } else {
                // 计算未税价
                row.ntxPrice = (parseFloat(row.wtxPrice / (1 + (row.taxRate * 0.01)))).toFixed(2);
                // 计算小计（含税小计，未税小计，税额小计）
                row.wtxAmount = (row.wtxPrice * quantity).toFixed(2);
                row.ntxAmount = (row.ntxPrice * quantity).toFixed(2);
                row.taxAmount = (row.wtxAmount - row.ntxAmount).toFixed(2);
            }
        },
        // 移除
        removeGoods: function (index) {
            let purchReceipt = this.purchReceipt || {};
            let goodsItemList = purchReceipt.goodsItemList || [];
            goodsItemList.splice(index, 1);
            purchReceipt.goodsItemList = Utils.merge([], goodsItemList);
            //
            this.purchReceipt = Utils.merge({}, purchReceipt);
        },
        // 上传附件信息
        showDialogFile: function () {
            let self = this;
            let fileList = self.fileList || [];
            let theDlg = Vue.$showDialog({
                title: '附件上传',
                width: 500,
                height: 200,
                showCloseBtn: true,
                okVisible: false,
                template: '<swb-file-upload-list :selectFileUuids="selectFileUuids" @handle-change="getSelectFileList" ref="swb_file_upload_list"></swb-file-upload-list>',
                data: {
                    selectFileUuids: fileList.pluck('fileUuid')
                },
                okClicked: function () {
                    let result = this.$refs.swb_file_upload_list.getFilesResult() || {};
                    if(result.type === 'info') {
                        let resultData = result.data || {};
                        //
                        let selectFileList = resultData.selectFileList || [];
                        self.fileList = Utils.merge([], selectFileList);
                        //
                        return true;
                    }
                    return false;
                },
                methods: {
                    getSelectFileList: function (selectFileList) {
                        let fileNames = selectFileList.pluck('name') || [];
                        let warnFlag = false;
                        let message = '';
                        for(let i = 0; i < selectFileList.length; i++) {
                            let fileInfo = selectFileList[i];
                            if(!Utils.isNoB(fileInfo.name) && fileInfo.name.length > 60) {
                                warnFlag = true;
                                message = '文件名称不可超过60个字符';
                                break;
                            }
                        }
                        for(let i = 0; i < fileList.length; i++) {
                            let fileInfo = fileList[i];
                            if(fileNames.indexOf(fileInfo.name) >= 0) {
                                warnFlag = true;
                                message = '文件名称[' + fileInfo.name + ']存在重复名称';
                                break;
                            }
                        }
                        if(warnFlag) {
                            MsgBox.warning(message);
                            return;
                        }
                        fileList = fileList.concat(selectFileList);
                        self.fileList = Utils.merge([], fileList);
                        theDlg.close();
                    }
                }
            });
        },
        deleteFile: function (index) {
            let fileList = this.fileList || [];
            fileList.removeAt(index.trackKey);
            //
            this.fileList = Utils.merge({}, fileList);
            return false;
        },
        validateWtxPrice: function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback(new Error('请输入含税单价'));
            } else {
                if(!Utils.isMoneyStr(value) || parseFloat(value) <= 0) {
                    callback(new Error('请输入大于0的金额'));
                } else {
                    callback();
                }
            }
        },
        // 返回数据
        getDlgResult: function () {
            let self = this;
            let result = {};
            this.$refs['ruleForm'].validate(function (valid) {
                if(valid) {
                    let purchReceipt = self.purchReceipt;
                    let goodsItemList = purchReceipt.goodsItemList || [];
                    if(Utils.isNoB(purchReceipt.taxRate)) {
                        result.type = 'warn';
                        result.message = '请选择税率!';
                    } else if(Utils.isNoB(purchReceipt.recvComId)) {
                        result.type = 'warn';
                        result.message = '请选择验收部门!';
                    } else if(Utils.isNoB(purchReceipt.sellerAdoptedComId)) {
                        result.type = 'warn';
                        result.message = '请选择供应商信息!';
                    } else if(goodsItemList.length <= 0) {
                        result.type = 'warn';
                        result.message = '请选择要验收条目!';
                    } else if(Utils.isNoB(purchReceipt.warehouseId)) {
                        result.type = 'warn';
                        result.message = '请选择入库仓库!';
                    } else {
                        // 循环 goodsItemList
                        for(let i = 0; i < goodsItemList.length; i++) {
                            let goodsItem = goodsItemList[i];
                            let wtxPrice = goodsItem.wtxPrice;
                            if(Utils.isNoB(wtxPrice) || !Utils.isMoneyStr(wtxPrice) || parseFloat(wtxPrice) <= 0) {
                                result.type = 'warn';
                                result.message = '验收条目【' + goodsItem.assetDefNo + '】的含税单价请输入大于0的金额!';
                                return result;
                            }
                        }
                        if(!Utils.isNoB(self.id)) {
                            purchReceipt.id = self.id;
                        }
                        let warehouseList = self.warehouseList || [];
                        for(let i = 0; i < warehouseList.length; i++) {
                            let warehouse = warehouseList[i];
                            if(purchReceipt.warehouseId == warehouse.id) {
                                purchReceipt.warehouseName = warehouse.name;
                                break;
                            }
                        }
                        if(!Utils.isNoB(self.fileList) && self.fileList.length > 0) {
                            purchReceipt.fileList = Utils.merge([], self.fileList);
                        }
                        result.type = 'info';
                        result.data = purchReceipt;
                    }
                } else {
                    result.type = 'warn';
                    result.message = '校验失败';
                }
            });
            return result;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/receipt/PurchReceiptTmpSave.vue